function addLookToWishlist()
{
    var btn = $(this);
    var products = [];
    var colors = [];
    var sizes = [];
    var needSizeId = [];
    var needColorId = [];

    var nbProducts = $("#products_look input[name='nb_products']").val();

    var i = 0;
    //get all product
    for (i = 0; i < nbProducts; i++) {
        var productId = $("#products_look input[name='products_" + i + "_product']").val();
        var colorId = $("#products_look input[name='products_" + i + "_color']").val();
        var sizeId = $("#products_look select[name='products_" + i + "_size']").val();
        if (!userWishlist.includes(productId + "_" + sizeId + "_" + colorId)) {
            products.push(productId);
            sizes.push(sizeId);
            colors.push(colorId);
            needSizeId.push("true");
            needColorId.push("true");
        }
    }

    if (products.length) {
        var data = {
            product_id: products,
            color_id: colors,
            size_id: sizes,
            need_size_id: needSizeId,
            need_color_id: needColorId
        };
        $.post(path_relative_root + "ajax_add_look_to_wishlist.php", data, function(resp) {
            if (resp.error == 0) {
                btn.addClass("existToWishlistButton");
                btn.attr('onclick','removeLookFromWishlist.call(this)');
            } else {
                alert(Translator.translate('error_insert_into_wishlist'));
            }
        });
    } else {
        btn.addClass("existToWishlistButton");
        btn.attr('onclick','removeLookFromWishlist.call(this)');
    }
}

function removeLookFromWishlist()
{
    var btn = $(this);
    var nbProducts = $("#products_look input[name='nb_products']").val();

    if (nbProducts) {
        var i = 0;
        var error = false;
        for (i = 0; i < nbProducts; i++) {
            var productId = $("#products_look input[name='products_" + i + "_product']").val();
            var colorId = $("#products_look input[name='products_" + i + "_color']").val();
            var sizeId = $("#products_look select[name='products_" + i + "_size']").val();
            if (productId) {
                var data = {
                    product_id: productId,
                    color_id: colorId,
                    size_id: sizeId,
                    remove: true
                };
                $.post(path_relative_root + "ajax_remove_from_wishlist.php", data, function(resp) {
                    if (resp.error == 0) {
                        btn.removeClass("existToWishlistButton");
                        btn.attr('onclick','addLookToWishlist.call(this)');
                    } else {
                        error = true;
                    }
                });
            }
        }
        setTimeout(function() {
            if (error) {
                alert(Translator.translate('error_remove_from_wishlist'));
            }
        }, 1000);
    } else {
        btn.removeClass("existToWishlistButton");
        btn.attr('onclick','addLookToWishlist.call(this)');
    }
}

function addLookToCart() {
    var loader = $("#addLookToBasket").parent().find(".loader");
    var errorBloc = $("#addLookToBasket").parent().find(".error");

    if (typeof loader != "undefined") {
        loader.addClass('loading');
    }

    loader.addClass("loading");
    errorBloc.hide();

    addOneProductToBasket(0);
}

function addOneProductToBasket(i)
{
    var loader = $("#addLookToBasket").parent().find(".loader");
    var errorBloc = $("#addLookToBasket").parent().find(".error");

    if ($("#products_look input[name='products_" + i + "_product']").length) {
        var productId = $("#products_look input[name='products_" + i + "_product']").val();
        var colorId = $("#products_look input[name='products_" + i + "_color']").val();
        var sizeId = $("#products_look select[name='products_" + i + "_size']").val();
        var qte = $("#products_look input[name='products_" + i + "_qte']").val();
        var price = $("#products_look input[name='products_" + i + "_price']").val();
        $.ajax({
            url: path_relative_root + 'ajax_upd_panier.php',
            data: {
                async: false,
                idprod: productId,
                prixu: price,
                panierid: 0,
                qte: qte,
                idcouleur: colorId,
                idtaille: sizeId,
                dataTypeReturn: 'json',
            },
            success : function(res) {
                let data = JSON.parse(res);
                if (!data.error) {
                    productAdded = true;
                    if ($("body").hasClass("mobile")) {
                        document.getElementById("cart_btn").setAttribute("data-cart", data.nb_article);
                    }
                } else if (data.error && data.error.code == 1) {
                    errorOutOfStock = true;
                    errorBloc.show();
                }
            }
        }).done(function() {
            
            var nbProducts = $("#products_look input[name='nb_products']").val();
            i++;
            if (i == nbProducts) {
                var isMobile = $("body").hasClass("mobile");
                if (isMobile) {
                    modBoxOpen.call(document.getElementById("item_added"));
                } else {
                    var response = ajax_file(path_relative_root + 'ajax_show_basket.php');
                    $("#cart_top").html(response);
                    var count_bask = $('#cart_top .cart').attr('data-cart');
        
                    if (count_bask > 0) {
                        CartShow();
                    }
                }
                if (typeof loader != "undefined") {
                    loader.removeClass('loading');
                }
            } else {
                addOneProductToBasket(i);
            }
        });
    }
}

function joinFidelityProgram() {
    var form = $("#joinFidelityProgramForm");
    $("#joinFidelityProgramForm .w-error").hide();
    $("#joinFidelityProgramForm .w-loader").addClass('loading');
    var checkbox = document.querySelector('input[name="optinFid"]');
    
    if (!(checkbox.checked)) {
        // Show error
        if(!$('#joinFidelityProgramForm .error_msg').length) {
            $("#joinFidelityProgramForm").append('<span class="error_msg">' + Translator.translate('error_submit_fid') + '</span>');
        }
        //Reset loader
        $("#joinFidelityProgramForm .w-loader").removeClass('loading');
    } else {
        $.ajax({
            type: 'post',
            data: form.serialize(),
            url: path_relative_root + 'ajax_join_fidelity_program.php',
            success: function (res) {
                if (res.success) {
                    if ($("body").hasClass("customer")) {
                        window.location.reload();
                    } else {
                        window.location.href = path_relative_root + create_link("client_fidelity");
                    }
                } else if (res.redirect_login) {
                    window.location.href = path_relative_root + create_link("connexion_login");
                } else {
                    $("#joinFidelityProgramForm .w-error").show();
                }
    
                setTimeout(function() {
                    $("#joinFidelityProgramForm .w-loader").removeClass('loading');
                }, 500);
            }
        });
    }
}

$(window).on("paypal_remote_button", function () {
    $('.payment_mode_btn[data-payment-mode = "paypal_remote"]').addClass('loading');
});

$(window).on("search_success", function () {
    scroolToProduct();
});

function deleteItemFromCart (id, qty) {
    if (typeof dataLayer_v3 !== 'undefined' && typeof dl_v3_impressions !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && id !== null && id !== undefined) {
        DataLayerTrigger.cart_product_action(dl_v3_impressions, dlv3_action_fields, id, "remove_from_cart", qty);
    }
}

$(function () {
    if($("#btn_pwd").length) {
        $("#clientForm").on("submit", function() {
            $("#btn_pwd").addClass("loader");
            setTimeout(function() {
                $("#btn_pwd").removeClass("loader");
            },2000);
        });
    }

    $(".basket_contents")
        .on('click touchstart', '.gift-options-updating .product_option, .gift-options-updating .product_option label, .gift-options-updating .product_option input', function(event) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        })
        .on('click', '.input_product_options', function() {
        if ($(this).closest('.basket_contents').hasClass('gift-options-updating')) {
            return false;
        }

        if ($(this).data('gift-option-updating')) {
            return false;
        }

        let parentBasketId = $(this).data('parent-basket-id');
        let basketId = $(this).data('basket-id');
        let productId = $(this).data('product-id');
        let carrierId = $(this).data('carrier-id');
        let sizeId = $(this).data('size');
        let colorId = $(this).data('color');
        if (parentBasketId && productId) {
            updateOption.call(this, parentBasketId, basketId, productId, colorId, sizeId, carrierId);
        }
    });

    if ($("body").hasClass("product_page")) {
        if ( $(".product_option").length) {
            getOptStock();
        }
    }

    // Add bandeau promo on owner's gift list page (Not for new gift lists with zero money given)
    if ($('body.gift_list_show').length && $('.gl_date_owner .gl_amount .number, .gl_date_owner .gl_amount .upselling').length) {
        $('.giftlist_infos .gl_date_owner').append(`
            <section class="naissance_bandeau_promo">
                <p>${Translator.translate('naissance_bandeau_promo_text')}</p>
            </section>
        `);
    }

    addParticipationMention();
});

function checkValidityRequestOfReturn() {
    var selectId = $(this).attr('id');
    var selectedValue = $(this).val();
    if (typeof selectId !== 'undefined') {
        if (selectId.includes("return_quantity")) {
            valueIdTailleQuantity = selectId.split("return_quantity_")[1];
            if (selectedValue != 0) {
                $('#' + selectId).addClass('choice_locked');
                if (!$('#return_choice_' + valueIdTailleQuantity).hasClass('choice_locked')) {
                    $('#return_choice_' + valueIdTailleQuantity).addClass('choice_unlocked_both').prop("disabled", false);
                    $('#' + selectId).addClass('choice_unlocked_both');
                }
            } else {
                if ($('#' + selectId).hasClass('choice_locked') && !$('#return_choice_' + valueIdTailleQuantity).hasClass('choice_locked')) {
                    $('#' + selectId).removeClass('choice_locked');
                    $('#return_choice_' + valueIdTailleQuantity).addClass('choice_unlocked_both');
                    $('#' + selectId).addClass('choice_unlocked_both');
                    if (document.querySelector('.choice_locked_both')) {
                        $('#return_choice_' + valueIdTailleQuantity).addClass('choice_locked_both');
                        $('#' + selectId).addClass('choice_locked_both');
                        $('#return_choice_' + valueIdTailleQuantity).removeClass('choice_unlocked_both');
                        $('#' + selectId).removeClass('choice_unlocked_both');
                    }
                } else if ($('#' + selectId).hasClass('choice_locked') && $('#return_choice_' + valueIdTailleQuantity).hasClass('choice_locked')) {
                    $('#' + selectId).removeClass('choice_locked');
                    $('#return_choice_' + valueIdTailleQuantity).removeClass('choice_locked');
                    $('#return_choice_' + valueIdTailleQuantity).addClass('choice_unlocked_both').prop("disabled", true);
                    $('#return_choice_' + valueIdTailleQuantity).val(0);
                    $('#' + selectId).addClass('choice_unlocked_both');
                    $('#return_choice_' + valueIdTailleQuantity).removeClass('choice_locked_both')
                    $('#' + selectId).removeClass('choice_locked_both');
                    if (document.querySelector('.choice_locked_both')) {
                        $('#return_choice_' + valueIdTailleQuantity).addClass('choice_locked_both');
                        $('#' + selectId).addClass('choice_locked_both');
                        $('#return_choice_' + valueIdTailleQuantity).removeClass('choice_unlocked_both');
                        $('#' + selectId).removeClass('choice_unlocked_both');
                    }
                } 
            }
        } else if (selectId.includes("return_choice")) {
            valueIdTailleChoice = selectId.split("return_choice_")[1];
            if (selectedValue != 0) {
                $('#' + selectId).addClass('choice_locked');
                $('#return_quantity_' + valueIdTailleChoice).addClass('choice_locked_both');
                $('#' + selectId).addClass('choice_locked_both');
                $('#return_quantity_' + valueIdTailleChoice).removeClass('choice_unlocked_both');
                $('#' + selectId).removeClass('choice_unlocked_both');
            } else {
                if ($('#' + selectId).hasClass('choice_locked') && $('#return_quantity_' + valueIdTailleQuantity).hasClass('choice_locked')) {
                    $('#' + selectId).removeClass('choice_locked');
                    $('#return_quantity_' + valueIdTailleChoice).addClass('choice_unlocked_both');
                    $('#' + selectId).addClass('choice_unlocked_both');
                    $('#return_quantity_' + valueIdTailleChoice).removeClass('choice_locked_both');
                    $('#' + selectId).removeClass('choice_locked_both');
                } 
            }
        }
    }

    if (!$('.choice_unlocked_both').length && $('.choice_locked').length) {
        $(".divBtnPrintPdf").show();
    } else {
        $(".divBtnPrintPdf").hide();
    }
}

$(document).ready(function () {
    $("select").change(function () {
        var selectedElement = $(this);
        checkValidityRequestOfReturn.call(selectedElement); 
    });

    initDailymotionVideos();
});

function searchSizeSort(sizes) {
    return sizes.sort(function(a, c) {
        if (typeof a.order === "undefined") {
            return a.label < c.label ? -1 : 1;
        } else {
            return parseInt(a.order) < parseInt(c.order) ? -1 : 1;
        }
    });
}

function waitingProcess(loader, action, id_form) {
    var elmt = $(this),
        loader = $(loader);

    prev_display = elmt.css("display");
    if (!loader.parent().hasClass("loading")) {
        loader.parent().addClass("loading");

        switch (action) {
            case 0:
                window.setTimeout(
                    ajax_checkAllForm,
                    1000,
                    tabAuthTop,
                    1,
                    path_relative_root
                );
                break;

            case 1:
                window.setTimeout(
                    ajax_checkAllForm,
                    1000,
                    tabLostPwdTop,
                    1,
                    path_relative_root
                );
                break;

            case 2:
                window.setTimeout(ajaxDeconnect, 1000, path_relative_root);
                break;

            case 3:
                window.setTimeout(function () {
                    checkAllForm(tabError, 0, path_relative_root, id_form);
                    loader.parent().removeClass("loading");
                }, 1000); // attention ne pas modifier le temps 1000 pour que le intelinput ai le temps de bien remplir les données
                break;

            case 4:
                window.setTimeout(
                    ajax_checkAllForm,
                    1000,
                    tabAuth,
                    1,
                    path_relative_root
                );
                break;

            case 5:
                window.setTimeout(
                    ajax_checkAllForm,
                    1000,
                    tabLostPwd,
                    1,
                    path_relative_root
                );
                break;

            case 6:
                window.setTimeout(checkFormParrainage, 1000);
                break;

            case 7:
                if (
                    checkAllForm(
                        tabErrorGrattez,
                        0,
                        path_relative_root,
                        id_form
                    )
                ) {
                    window.setTimeout(processGrattezGagnez(), 1000);
                }
                break;
        }
    }
}

/***
 *Client disconnexion
 */
 function ajaxDeconnect(path_relative_root) {

    var provenance = window.location.pathname,
        cpt_client = new RegExp(/(?:adresses|mes_infos|newsletter|parrainage|mon-compte|facture-liste|avoir-liste|commande_detail|panier|livraison-kiala|livraison|paiement|banque|erreur_cmd|erreur_commande|banque_refus|remerciements|endereco|newsletter-pt|conta|conta-lista|haver-lista|encomenda_detalhes|cesta|remessa|pagamento|banco|erreur_cmd_pt|erros-encomenda|banco-recusa|agradecimento)/),
        response;

    // Get the current page's name
    provenance = provenance.substr(provenance.lastIndexOf('/'), provenance.lastIndexOf('.'));

    // This actually disconnects the client
    response = ajax_file(path_relative_root + 'ajax_deconnect.php');

    // If there was an error
    if (!response)
        alert('Erreur lors de la déconnexion.');

    // Else if the current page can't be displayed when not logged in: redirect
    else if (cpt_client.test(provenance))
        window.location.href = path_relative_root + create_link('connexion_login');

    // Else: refresh
    else window.location.reload();

    // If the page hasn't been reloaded: remove the loader and return false
    hideLoader();

    return false;
}

/**
 * Adds a configured product to the virtual basket and updates the cart UI.
 * 
 * This function retrieves product details (product ID, color ID, size ID) and 
 * selected options, then sends AJAX requests to add the main product and its 
 * configured options to the virtual basket. It also updates the cart display 
 * based on the response.
 * 
 * @async
 * @function addConfiguredProduct
 * 
 * @returns {Promise<void>} Resolves when the product and its options are successfully added to the basket.
 * 
 * @throws {Error} Logs an error to the console if there is an issue with the AJAX response or JSON parsing.
 */
async function addConfiguredProduct() {
    var productId = $('#produit_id').val();
    var colorId = ($('#couleurProd').length > 0) ? $('#couleurProd').val() : $('#prod_couleur').val();
    var sizeId = ($('#tailleProd').length > 0) ? $('#tailleProd').val() : $('#prod_taille').val();

    let checkboxes = document.getElementsByName('options');
    var configuredProductIds = [];
    for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
            configuredProductIds.push({
                productId: checkboxes[i].value,
                colorId: checkboxes[i].getAttribute('data-color'),
                sizeId: checkboxes[i].getAttribute('data-size'),
            });
        }
    }
    $.ajax({
        url: path_relative_root + "ajax_upd_panier.php",
        type: "post",
        dataType: 'json',
        data: {
            configurator: true,
            idprod: productId,
            idcouleur: colorId,
            idtaille: sizeId,
            panierid: 0,
            qte: 1,
            configurator_product: false,
            dataTypeReturn: 'json',
            reinit_basket_virtuel_parent_id: true,
            virtual_basket: true,
            get_carrier: true,
        },
        success: async function (res) {
            try {
                let carrierId = res.carrier_id;
                let virtualBasketId = res.panier_virtuel_id;
                let nbOpts = configuredProductIds.length;
                if (res.error == 0) {
                    for (let i = 0; i < nbOpts; i++) {
                        await $.ajax({
                            url: path_relative_root + "ajax_upd_panier.php",
                            type: "post",
                            dataType: 'json',
                            data: {
                                configurator: true,
                                idprod: configuredProductIds[i].productId,
                                idcouleur: configuredProductIds[i].colorId,
                                idtaille: configuredProductIds[i].sizeId,
                                basket_virtuel_parent_id: res.panier_virtuel_id,
                                qte: 1,
                                configurator_product: true,
                                dataTypeReturn: 'json',
                                reinit_basket_virtuel_parent_id: false,
                                force_carrier_id: carrierId,
                            },
                            success: function (res) {
                                try {
                                    if (res.error == 0) {

                                        if (i == (configuredProductIds.length - 1)) {
                                            if ($('body').hasClass('mobile')) {
                                                $("#item_added").addClass('open');
                                                modBoxOpen.call(document.getElementById("#item_added"));
                                            } else {
                                                //update top cart
                                                let response = ajax_file(path_relative_root + "ajax_show_basket.php");
                                                cart = Translator.translate('mon_panier');
                                                document.getElementById('cart_top').innerHTML = response;
                                                let total = $('#cart_top .cart').attr('data-cart');

                                                let text = (total <= 1)
                                                    ? Translator.translate('one_product')
                                                    : Translator.translate('2_product');

                                                $('.cart_main_title.basket').html(cart
                                                    + '<span class="nb_products">'
                                                    + '<span class="parenthesis">(</span>'
                                                    + total + ' ' + text
                                                    + '<span class="parenthesis">)</span>'
                                                    + '</span>'
                                                );
                                                CartShow();
                                            }
                                        }
                                        return true;
                                    } else {
                                        removeOptFromBasket(virtualBasketId);
                                        i = nbOpts + 1;
                                        alert(res.error.msg);
                                    }
                                    return false;
                                } catch (e) {
                                    console.error('JSON ERROR: could not parse data');
                                    return false;
                                }
                            }
                        });
                    }
                } else {
                    alert(res.error.msg);
                }
            } catch (e) {
                console.error('JSON ERROR: could not parse data');
                return false;
            }
        }
    });
}

function updateOption(parentBasketId, basketId, productId, colorId, sizeId, carrierId)
{
    let $optionInput = $(this);
    let $basketContents = $optionInput.closest('.basket_contents');
    let checked = this.checked;
    let previousCheckedState = !checked;
    let requestSucceeded = false;
    let waitingForTunnelReload = false;

    if ($optionInput.data('gift-option-updating') || $basketContents.hasClass('gift-options-updating')) {
        return false;
    }

    $basketContents.addClass('gift-options-updating');
    $optionInput
        .data('gift-option-updating', true)
        .prop('disabled', true)
        .closest('.product_option')
        .addClass('is-updating');

    let releaseOptionLock = function () {
        if (!requestSucceeded && $optionInput.length) {
            $optionInput.prop('checked', previousCheckedState);
        }

        $optionInput
            .data('gift-option-updating', false)
            .prop('disabled', false)
            .closest('.product_option')
            .removeClass('is-updating');

        $basketContents.removeClass('gift-options-updating');
    };

    if (checked) {
        $.ajax({
            url: path_relative_root + "ajax_upd_panier.php",
            type: "post",
            dataType: 'json',
            data: {
                configurator: true,
                idprod: productId,
                idcouleur: colorId,
                idtaille: sizeId,
                basket_virtuel_parent_id: parentBasketId,
                qte: 1,
                configurator_product: true,
                dataTypeReturn: 'json',
                reinit_basket_virtuel_parent_id: false,
                force_carrier_id: carrierId,
            },
            success: function (res) {
                try {
                    if (res.error == 0) {
                        requestSucceeded = true;
                        waitingForTunnelReload = true;
                        $(window).one('reloadLeftAndRightTunnel_complete.giftOptionLock', function () {
                            waitingForTunnelReload = false;
                            releaseOptionLock();
                        });

                        if (!$('body').hasClass('mobile')) {
                            var response = ajax_file(path_relative_root + "ajax_show_basket.php");
                            document.getElementById('cart_top').innerHTML = response;
                        }
                        reloadLeftAndRightTunnel({
                            returnHtml : "ajax"
                        }, false);
                        return true;
                    } else {
                        alert(res.error.msg);
                    }
                    return false;
                } catch (e) {
                    console.error('JSON ERROR: could not parse data');
                    return false;
                }
            },
            error: function () {
                alert(Translator.translate('error'));
                return false;
            },
            complete: function () {
                if (!waitingForTunnelReload) {
                    releaseOptionLock();
                }
            }
        });
    } else {
        // remove product from basket
        $.ajax({
            url: path_relative_root + "ajax_removeBasketProd.php",
            type: "post",
            dataType: 'json',
            data: {
                basket_id: basketId,
                prod_id: productId,
                qte: 1,
                dataTypeReturn: 'json',
            },
            success: function (res) {
                try {
                    requestSucceeded = true;
                    waitingForTunnelReload = true;
                    $(window).one('reloadLeftAndRightTunnel_complete.giftOptionLock', function () {
                        waitingForTunnelReload = false;
                        releaseOptionLock();
                    });

                    $('#cart_top').html(res.datas.html);
                    reloadLeftAndRightTunnel({
                        returnHtml : "ajax"
                    }, false);
                    return true;
                } catch (e) {
                    console.error('JSON ERROR: could not parse data');
                    return false;
                }
            },
            error: function () {
                alert(Translator.translate('error'));
                return false;
            },
            complete: function () {
                if (!waitingForTunnelReload) {
                    releaseOptionLock();
                }
            }
        });
    }
}

function removeOptFromBasket(virtualBasketId)
{
    $.ajax({
        url: path_relative_root + "ajax_removeBasketProd.php",
        type: "post",
        dataType: 'json',
        data: {
            basket_id: virtualBasketId,
            qte: 1,
            dataTypeReturn: 'json',
        }
    });
}

/**
 * Get stock of all product of the page
 */
function getOptStock()
{
    var productIdsAll = $.find('.product_option');
    var productIdsNew = new Array();

    if (productIdsAll.length) {
        for (var indexId = 0; indexId < productIdsAll.length; indexId++) {
            var currentProductId = $(productIdsAll[indexId]).attr('data-id');
            if (!productIdsNew.includes(currentProductId)) {
                productIdsNew.push(currentProductId);
            }
        }
    }

    $.ajax({
        url : path_relative_root + 'ajax_get_colisages_states_by_color_size.php',
        type : 'post',
        data : {produit_id: productIdsNew},
        success : function (res) {
            try {
                res = $.parseJSON(res);
            } catch (e) {
                console.error("parseJSON");
                return;
            }

            if (res.success && res.result) {
                var result = res.result;

                // On stock les informations dans le tableau JS
                Object.entries(result).forEach(entry => {
                    const [idProduct, objProduct] = entry;
                    var qty = objProduct.stock_quantite;
                    if (qty > 0) {
                        $(".product_option[data-id='" + idProduct + "']").removeClass('hideOpt');
                    } else {
                        $(".product_option[data-id='" + idProduct + "']").addClass('hideOpt');
                    }
                });
            }
        }
    });
}

/* PROD ASSOCS DATA LAYERS */
function dataLayer_associated_product () {
    if ($(this).parents("#assoc_product_slider").length) {
        var product_id = this.getAttribute('data-prodid') ? event.currentTarget.getAttribute('data-prodid') : '';
        if (product_id !== '') {
            if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null) {
                DataLayerTrigger.selectItem(dl_v3_impressions_like, dlv3_action_fields_like, product_id);
            }
        };
    }

    if ($(this).parents("#assoc_product_slider_Fp").length) {
        var product_id = this.getAttribute('data-prodid') ? event.currentTarget.getAttribute('data-prodid') : '';
        if (product_id !== '') {
            if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null) {
                DataLayerTrigger.selectItem(dl_v3_impressions_look, dlv3_action_fields_look, product_id);
            }
        }
    }
}

/**
 * Set the stocks of a product in the global `productColisages` object.
 *
 * @param {string} productId
 * @param {object} stocks Sorted by color ID, then by size ID.
 */
function setProductColorStocks(productId, stocks) {
    if (window.productColisages === undefined) {
        window.productColisages = {};
    }

    var product = {};

    for (colorId in stocks) {
        if (typeof stocks[colorId] == 'object') {
            product[colorId] = stocks[colorId];
        }
    }

    window.productColisages[productId] = product;
}

/**
 * Fetch existing product color stocks from the global `productColisages` object.
 *
 * @param {string} productId - The ID of the product.
 * @param {string|null} colorId - The ID of the color (optional).
 *
 * @returns {object|boolean} - Returns the stocks if they exist, otherwise returns false.
 */
function fetchExistingProductColorStocks(productId, colorId = null) {
    if (window.productColisages === undefined) {
        window.productColisages = {};
    }

    if (
        window.productColisages[productId] !== undefined &&
        (colorId == null || window.productColisages[productId][colorId] !== undefined)
    ) {
        var result = colorId ? window.productColisages[productId][colorId] : window.productColisages[productId];

        return result;
    }

    return false;
}

/**
 * Fetch product's color stocks, either from the global `productColisages` object or by making an AJAX request.
 *
 * @param {string} productId - The ID of the product.
 * @param {string|null} colorId - The ID of the color (optional).
 *
 * @returns {Promise<object>} - A promise that resolves to the product stocks.
 */
function fetchProductColorStocks(productId, colorId = null) {
    var existingStocks = fetchExistingProductColorStocks(productId, colorId);

    if (existingStocks !== false) {
        return Promise.resolve(existingStocks);
    }

    return fetchProductStocks([productId]).then(function () {
        var productStocks = colorId ? window.productColisages[productId][colorId] || {} : window.productColisages[productId] || {};

        return productStocks;
    });
}

/**
 * Fetch stocks for multiple products by their IDs.
 *
 * @param {Array<string>} productIds - An array of product IDs to fetch stocks for.
 *
 * @returns {Promise<void>} - A promise that resolves when the stocks have been fetched and set.
 */
function fetchProductStocks(productIds) {
    var data = {produit_id: productIds};

    if (typeof isGlobalEActive == 'undefined') {
        isGlobalEActive = false;
    }

    if (isGlobalEActive) {
        data.warehouse_only = 1;
    }

    return $.ajax({
        url : path_relative_root + 'ajax_get_colisages_states_by_color_size.php',
        type : 'POST',
        data : data
    }).then(function (response) {
        try {
            response = $.parseJSON(response);
        } catch (e) {
            console.error("parseJSON");

            throw new Error("Invalid JSON response");
        }

        if (response.success && response.result) {
            var result = response.result;

            for (resultProductId in result) {
                setProductColorStocks(resultProductId, result[resultProductId]);
            }
        }
    });

}

/**
 * Update the stock status of associated products in the look product page
 *
 * @returns {void}
 */
function updateAssociatedProductStock() {
    var productsContainer = $('#products_look');
    var products = productsContainer.find('.associated_product');

    var productElements = products.find('.associated-product-id').get();
    var productIds = productElements.map((e) => e.value);

    fetchProductStocks(productIds).then(function() {
        products.each(function(index, product) {
            var $product = $(product);
            var productId = $product.find('.associated-product-id').val();
            var colorId = $product.find('.associated-product-color').val();

            var stocks = fetchExistingProductColorStocks(productId, colorId);
            for (sizeId in stocks) {
                var $option = $product.find('.associated_product_sizes option[value=' + sizeId + ']');

                if (stocks[sizeId]) {
                    $option.removeClass('product_unavailable')
                        .text($option.data('label'));
                } else {
                    $option.addClass('product_unavailable')
                        .text($option.data('label') + ' ' + Translator.translate('store_product_unavailable'));
                }
            }
        });

        // Update the wishlist button
        getWishlistProducts(true);
    });
}

function addParticipationMention() {
    var container = $(".list_regroup_content .lightbox");
    if (container.length) {
        var mentionDiv = $('<div class="gl_mention">' + Translator.translate('participation_mention') + '</div>');
        container.find(".w-form-line.w-submit").before(mentionDiv);
    }
}